import { FilterField, labelId } from "kontrolEdge/helpers/advancedFilters";
import { BgpStatus } from "./BgpStatusData";

export function makeBgpStatusFields(): FilterField<BgpStatus>[] {
  const fields: FilterField<BgpStatus>[] = [
    {
      label: "CTX-R",
      key: "ctxr",
      accessor: (r) => r.ctxr,
      type: "string",
      inFreeText: true,
    },
    {
      label: "CTX-R Description",
      key: "ctxrdescription",
      accessor: (r) => r.ctxr_description,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Neighbor",
      key: "neighbor",
      accessor: (r) => r.neighbor,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Neighbor Description",
      key: "neighbordescription",
      accessor: (r) => r.description || "",
      type: "string",
      inFreeText: true,
    },
    {
      label: "State",
      key: "state",
      accessor: (r) => r.state,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Up Time",
      key: "uptime",
      accessor: (r) => r.up,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Local AS",
      key: "localas",
      accessor: (r) => r.local_as.toString(),
      type: "string",
      inFreeText: true,
    },
    {
      label: "Peer AS",
      key: "peeras",
      accessor: (r) => r.peer_as.toString(),
      type: "string",
      inFreeText: true,
    },
    {
      label: "Prefix In",
      key: "prefixin",
      accessor: (r) => r.in.toString(),
      type: "string",
      inFreeText: true,
    },
    {
      label: "Prefix Out",
      key: "prefixout",
      accessor: (r) => r.out.toString(),
      type: "string",
      inFreeText: true,
    },
  ];

  // Ensure keys are set
  for (const f of fields) f.key ||= labelId(f.label);
  return fields;
}

